export const normalizeEmail = (value: string) => {
  return value.toLowerCase();
};
